var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTv(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 54,
    height: 40,
    fill: "none",
    viewBox: "0 0 54 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#009fca",
    d: "M0 0h53.3v40H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff40d",
    fillRule: "evenodd",
    d: "M49.4 10.2h2.3L50 11.5l.7 2-1.9-1.2-1.8 1.3.7-2.1-1.9-1.3H48l.7-2zm-5.7 16.4H46L44 28l.7 2-1.8-1.2L41 30l.7-2.1-1.8-1.3h2.2l.8-2zm5.7-3.7h2.3L50 24.2l.7 2-1.9-1.2-1.8 1.2.7-2-1.9-1.3H48l.7-2zM24.6 35H27l-1.9 1 .7 2-1.9-1.2-1.8 1.2.7-2-1.9-1.3h2.3l.7-2zm5.3-6.5h-2.3l1.8-1.2-.7-2 1.9 1.2 1.8-1.3-.7 2 1.9 1.3h-2.3l-.7 2zm6.7-9.3h-2.3l1.9-1.3-.7-2 1.8 1.2 1.9-1.3-.7 2 1.8 1.4H38l-.7 2zm5.7-2H40l1.9-1.3-.7-2L43 15l1.9-1.3-.7 2L46 17h-2.3l-.7 2zm-5.7 16.2h-2.3l1.9-1.2-.7-2.1 1.9 1.3 1.8-1.3-.7 2 1.9 1.3H38l-.7 2zM30 35h-2.3l1.8-1.3-.7-2 1.9 1.2 1.8-1.2-.7 2 1.9 1.3h-2.3l-.7 2z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#012169",
    d: "M0 0h26.7v20H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m3.1 0 10.2 7.5L23.4 0h3.3v2.6l-10 7.4 10 7.5V20h-3.4l-10-7.5-10 7.5H0v-2.5l10-7.4L0 2.7V0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c8102e",
    d: "m17.7 11.7 9 6.6V20l-11.3-8.3zm-7.7.8.2 1.5-8 6H0zM26.7 0v.1L16.3 8V6l8.4-6zM0 0l10 7.3H7.5L0 1.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M10 0v20h6.7V0zM0 6.7v6.6h26.7V6.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c8102e",
    d: "M0 8v4h26.7V8zm11.4-8v20h4V0z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h53.3v40H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTv);
export default __webpack_public_path__ + "static/media/tv.f0a25939e3107003fdd9debb5b5ce577.svg";
export { ForwardRef as ReactComponent };